// This hook will extract either group_number or SSN
import { useEffect, useState } from "react";
import { UseRouteParamProps } from "../@types/components/hooksProps.types";
import useQuery from "./useQuery";

const useRouteParam = (searchString: UseRouteParamProps): string | number | undefined | null => {
	const [routeParam, setRouteParam] = useState<string | number>();
	const query = useQuery();

	useEffect(() => {
		if (query && query.get(searchString)) {
			if (searchString === "qs") {
				setRouteParam(String(query.get("qs") as string) as string);
			} else if (searchString === "gn") {
				setRouteParam(Number(query.get("gn")) as number);
			} else if (searchString === "ln") {
				setRouteParam(Number(query.get("ln")) as number);
			} else {
				setRouteParam(query.get(searchString) as string);
			}
		}
	}, [query, searchString]);

	return routeParam ? routeParam : null;
};

export default useRouteParam;
